<template>
  <div :class="{half: half}" class="no-content">
    <div class="icon">
      <i class="material-icons icon-i">{{ icon || "gesture" }}</i>
    </div>
    <div class="message">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoContent",
  props: ["icon", "half"]
};
</script>

<style lang="scss" scoped>
.icon {
  padding: 30px;
  text-align: center;
}

.icon-i {
  font-size: 45pt;
  color: lighten($color-blue, 0%);
}

.message {
  font-size: 15pt;
  color: lighten($color-blue, 0%);
  text-align: center;
  font-family: $font-family;
}

.half {
  width: 50%;
}

@media (max-width: 1024px) {
  .no-content {
    padding-bottom: 30px;
  }
}
</style>
